import angular from 'angular';
import monthDayIcon from './monthDayIcon';
import './style.scss';

export default angular
  .module('components.monthDayIcon', [])
  .component('monthDayIcon', monthDayIcon).name;
